export const visit = (vm, at) => {
at({ "en": { "compareCreditPlansBanner": { "title": "HubSpot Credits", "subtitle": "Compare our plans for powerful AI, Enrichment and Data Activation", "buttonCTA": "Estimate credits" } } });
};